<template>
  <MainLayout selectMenu="10-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else class="setting-container">
      <Card class="card-container " dis-hover>
        <div slot="title" class="card-title">
          {{ getTranslation('s336') }}
        </div>
        <Row type="flex">
          <Col flex="1">
          </Col>
          <Col flex="4">
          <Row class="form-row normal-hover">
            <Col flex="1">
            <p class="description">{{ getTranslation('s337') }}</p>
            </Col>
            <Col flex="1">
            <Input type="number" v-model="setting.machineProcess" class="short-text" />
            </Col>
          </Row>
          <Row type="flex" class="form-row normal-hover">
            <Col flex="1">
            <p class="description">{{ getTranslation('s338') }}</p>
            </Col>
            <Col flex="1">
            <Input v-model="setting.hrc670Dir" placeholder="C:\Program Files" class="long-text" />
            </Col>
          </Row>
          <Row class="form-row normal-hover">
            <Col flex="1">
            <p class="description">{{ getTranslation('s339') }}</p>
            </Col>
            <Col flex="1">
            <Input type="number" v-model="setting.hrc670Port" disabled class="short-text" />
            </Col>
          </Row>


          <Row class="form-row normal-hover">
            <Col flex="1">
            <p class="description">{{ getTranslation('i030') }}</p>
            </Col>
            <Col flex="1">
            <i :class="['status-dot', {'status-offline':tcp_service=='0'}, {'status-online':tcp_service=='1'}]" ></i>
            </Col>
          </Row>
          <Row class="form-row normal-hover">
            <Col flex="1">
            <p class="description">{{ getTranslation('i031') }}</p>
            </Col>
            <Col flex="1">
            <i :class="['status-dot', {'status-offline':ssh_service=='0'}, {'status-online':ssh_service=='1'}]" ></i>
            </Col>
          </Row>

          <Row class="form-row normal-hover">
            <Col flex="1">
            <p class="description">{{ getTranslation('i024') }}</p>
            </Col>
            <Col flex="1">
            <i-switch type="info" v-model="machineBackup.open" />&nbsp;
            <RadioGroup v-if="machineBackup.open == true" v-model="machineBackup.timeRange">
              <Row type="flex" class="field-line menu-actions">                
                <Col flex="1">
                <Radio label="1 MONTH" border>{{ getTranslation('i017') }}</Radio>
                </Col>
                <Col flex="1">
                <Radio label="3 MONTH" border>{{ getTranslation('i018') }}</Radio>
                </Col>
                <Col flex="1">
                <Radio label="6 MONTH" border>{{ getTranslation('i019') }}</Radio>
                </Col>
                <Col flex="1">
                <Radio label="1 YEAR" border>{{ getTranslation('i020') }}</Radio>
                </Col>
              </Row>
            </RadioGroup>
            </Col>
          </Row>

          <Row class="form-row normal-hover" type="flex">
            <Col flex="1">
            <p class="description">{{ getTranslation('i026') }}</p>
            </Col>
            <Col flex="1">
              <CheckboxGroup v-model="initRecord.options">
              <Row type="flex" class="field-line menu-actions">
                <Col flex="1">
                <i-switch type="info" v-model="initRecord.open" />&nbsp;
                <template v-if="initRecord.open == true">
                  <RadioGroup v-if="initRecord.open == true" v-model="initRecord.timeRange">
                  <Row type="flex" class="field-line menu-actions">
                    <Col flex="1">
                    <Radio label="1 WEEK" border>{{ getTranslation('i034') }}</Radio>
                    </Col>
                    <Col flex="1">
                    <Radio label="1 MONTH" border>{{ getTranslation('i017') }}</Radio>
                    </Col>
                    <Col flex="1">
                    <Radio label="3 MONTH" border>{{ getTranslation('i018') }}</Radio>
                    </Col>
                    <Col flex="1">
                    <Radio label="6 MONTH" border>{{ getTranslation('i019') }}</Radio>
                    </Col>
                    <Col flex="1">
                    <Radio label="1 YEAR" border>{{ getTranslation('i020') }}</Radio>
                    </Col>
                  </Row>
                </RadioGroup>
                <br />
                <Checkbox label="record" class="chk-line" >{{ getTranslation('i003') }}</Checkbox>               
                <Checkbox label="curve" class="chk-line" >{{ getTranslation('i004') }}</Checkbox>
                <Checkbox label="expulsion_daily" class="chk-line" >{{ getTranslation('e019') }}</Checkbox>
                </template>
                </Col>                
              </Row>
            </CheckboxGroup>
            </Col>
          </Row>

          <Row class="form-row normal-hover">
            <Col flex="1">
            <p class="description">{{ getTranslation('e031') }}</p>
            </Col>
            <Col flex="1">
            <i-switch type="info" v-model="setting.openVinInt" true-value="1" false-value="0" />
            </Col>
          </Row>

          <Row class="menu-actions">
            <Col flex="2" class="flex-middle">
            <p class="description"><Button type="success" icon="md-checkmark-circle" @click="saveData">{{
                getTranslation('c006') }}</Button></p>
            </Col>
          </Row>
          </Col>
          <Col flex="1">
          </Col>
        </Row>
      </Card>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import NoAuth from '@/components/NoAuth.vue'
import { Card, Input, Button, Row, Col, Switch, Radio, RadioGroup,CheckboxGroup,Checkbox } from 'view-design'
import { mapGetters } from 'vuex'
import { API_URL } from '@/constants/const.js'
import axios from 'axios'
import { postJsError } from '@/util/util.js'

export default {
  name: 'RegisterIndex',
  components: {
    MainLayout,
    NoAuth,
    Card,
    Input,
    Button,
    Row,
    Col,
    "i-switch": Switch, RadioGroup, Radio, CheckboxGroup, Checkbox
  },
  props: {},
  data() {
    return {
      hasAuth: true,
      serialNumber: '',
      registrationCode: '',
      localRegisterCode: '',
      loading: false,
      message: '',
      messageType: '', // 'success' or 'error'
      setting: {},
      machineBackup: {},
      initRecord: {},
      tcp_service: '0',
      ssh_service: '0',
      
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
  },
  mounted() { },
  created() {
    this.setBreadcrumbItems()
    this.getData()
  },
  methods: {
    async getData() {
      const url = API_URL['settingInit']
      const res = await axios.get(url
      ).catch((err) => {
        postJsError(err)
      })
      if (res && res.data && res.data.code === 200) {
        this.setting = res.data.data.setting || {};
        this.tcp_service = res.data.data.tcp_service || '0';
        this.ssh_service = res.data.data.ssh_service || '0';
        this.parseBackupSetting();
        this.parseInitRecordSetting();        
      } else if (res && res.data && res.data.code == 3001) {
        this.hasAuth = false;
      } else if (res && res.data && res.data.msg) {
        this.$Message.error(res.data.msg);
      } else {
        this.$Message.error(this.getTranslation('c001'));
      }
    },
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['s336']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('s336') }
        ])
      }      
    },
    saveData() {
      const url = API_URL['settingUpdate']
      this.loading = true
      if (this.isInvalid()) {
        return;
      }
      if (this.machineBackup) {
        this.setting.machineBackup = JSON.stringify(this.machineBackup);
      }
      if (this.machineBackup) {
        this.setting.machineBackup = JSON.stringify(this.machineBackup);
      }
      if (this.initRecord) {
        this.setting.initRecord = JSON.stringify(this.initRecord);
      }
      if(this.setting.openVinInt == true){
        this.setting.openVinInt = "1";
      } else {
        this.setting.openVinInt = "0";
      }
      axios.post(url, this.setting
      ).then((res) => {
        this.loading = false
        if (res && res.data && res.data.code === 200) {
          this.$Message.success(res.data.msg)
        } else if (res && res.data && res.data.msg) {
          this.$Message.error(res.data.msg)
        } else {
          this.$Message.error(this.getTranslation('c001'))
        }
      }).catch((err) => {
        this.loading = false
        postJsError(err)
      })
    },
    parseBackupSetting() {
      if (this.setting && this.setting.machineBackup) {
        try {
          let backupData = JSON.parse(this.setting.machineBackup);
          this.machineBackup = backupData
        } catch (e) {
          postJsError(e)
        }

      } else {
        this.machineBackup = {};
      }
    },
    parseInitRecordSetting() {
      if (this.setting && this.setting.initRecord) {
        try {
          let recordData = JSON.parse(this.setting.initRecord);
          this.initRecord = recordData
        } catch (e) {
          postJsError(e)
        }
      } else {
        this.initRecord = {};
      }
    },  
    isInvalid() {
      let rs = false;
      if (this.machineBackup.open == true && (!this.machineBackup.timeRange || this.machineBackup.timeRange == '')) {
        this.$Message.error(this.getTranslation('i025'));
        rs = true;
      }      
      if (this.initRecord.open == true && (!this.initRecord.options || this.initRecord.options.length == 0)) {
        this.$Message.error(this.getTranslation('i027'));
        rs = true;
      } else if (this.initRecord.open == true && (!this.initRecord.timeRange || this.initRecord.timeRange == '')) {
        this.$Message.error(this.getTranslation('i028'));
        rs = true;
      }
      return rs;
    }

  }
}
</script>
<style></style>
<style scoped>
@import url('../../assets/style/list.css');
@import url('../../assets/style/tab.css');

.form-row {
  margin-bottom: 6px;
}

.long-text {
  width: 80%;
}

.short-text {
  width: 78px;
}

::v-deep(.ivu-input.ivu-input-disabled),
::v-deep(.ivu-input[disabled]) {
  color: #999 !important;
  background-color: #f8f9fa !important;
  border-color: #ced4da !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #999 !important;
}
.chk-line {
  margin-top: 4px;
}
</style>

